<template>
  <div class="Course">
    <div class="header">
      <div class="headerL">
        <el-form ref="form" :model="form" :inline="true" class="form">
          <el-form-item prop="courseId">
            <el-select v-model="form.courseId" placeholder="请选择课程" clearable>
              <el-option
                v-for="item in courseSelect"
                :key="item.courseId"
                :label="item.courseName"
                :value="item.courseId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <el-button @click="exportRecord">导出记录</el-button>
    </div>
    <table-list
      :loading="loading"
      :data="list"
      :columns="columns(this)"
      :pager="pager"
      :options="{ selection: true }"
      @selectionChange="handleSelectionChange"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </table-list>
  </div>
</template>

<script>
// 表格列配置
const columns = () => [
  {
    prop: 'studentName',
    label: '员工名称',
    minWidth: 120,
  },
  {
    prop: 'phone',
    minWidth: 120,
    label: '手机号',
  },
  {
    prop: 'courseName',
    minWidth: 200,
    label: '课程名称',
  },
  {
    prop: 'punchCount',
    minWidth: 100,
    sortable: true,
    align: 'right',
    label: '打卡次数',
  },
  {
    prop: 'userCredit',
    minWidth: 100,
    sortable: true,
    align: 'right',
    label: '获得学分',
  },
  {
    prop: 'courseCredit',
    minWidth: 100,
    sortable: true,
    align: 'right',
    label: '总学分',
  },
  {
    prop: 'studyDuration',
    minWidth: 100,
    label: '已学时长数',
  },
  {
    prop: 'courseDuration',
    minWidth: 100,
    label: '应学时长数',
  },
  {
    prop: 'studySectionCount',
    minWidth: 100,
    label: '已学章节数',
  },
  {
    prop: 'sectionCount',
    label: '应学章节数',
    minWidth: 100,
  },
  {
    prop: 'progress',
    label: '学习进度',
    minWidth: 120,
    sortable: true,
    align: 'right',
  },
]
import TableList from '@/components/TableList'
import { courseSelect, courseStudy, courseExport } from '@/api/class'
import to from 'await-to'
export default {
  components: {
    TableList,
  },
  props: {
    classId: {
      type: String,
      default: '',
    },
    activeIndex: {
      type: String,
      default: '1',
    },
    userId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      columns,
      form: {},
      courseSelect: [],
      list: [],
      pager: {
        total: 0,
        size: 10,
        current: 1,
      },
      select: [],
    }
  },
  watch: {
    activeIndex: {
      handler(val) {
        if (val == 1) {
          this.courseSelectData()
          this.courseStudyData()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    async courseSelectData() {
      const [res, err] = await to(courseSelect({ classId: this.classId }))
      if (err) return this.$message.warning(err.msg)
      this.courseSelect = res.data
    },
    async courseStudyData() {
      const { current, size } = this.pager
      this.loading = true
      const [res, err] = await to(
        courseStudy({
          classId: this.classId,
          current,
          size,
          userId: this.userId,
          courseId: this.form.courseId,
        }),
      )
      this.loading = false
      if (err) return this.$message.warning(err.msg)
      this.list = res.data.list
      this.pager.total = res.data.total
    },
    exportRecord() {
      if (this.select.length) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        // 导出表格的表头设置
        let allColumns = columns(this)
        var columnNames = []
        var columnValues = []
        for (var i = 0; i < allColumns.length; i++) {
          columnNames[i] = allColumns[i].label
          columnValues[i] = allColumns[i].prop
        }
        require.ensure([], () => {
          const { export_json_to_excel } = require('@/vendor/Export2Excel')
          const tHeader = columnNames
          const filterVal = columnValues
          const list = this.select
          const data = this.formatJson(filterVal, list)
          export_json_to_excel(tHeader, data, '课程学习统计记录')
        })
        loading.close()
      } else {
        this.exportData()
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    async exportData() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const [res, err] = await to(
        courseExport({
          classId: this.classId,
          userId: this.userId,
          courseId: this.form.courseId,
        }),
      )
      loading.close()
      if (err) return this.$message.warning(err.msg)
      let blob = new Blob([res], {
        type: 'application/vnd.ms-excel',
      })
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = '课程学习统计记录.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    resetForm() {
      this.form = Object.assign({}, {})
    },
    // 分页
    handleSizeChange(size) {
      this.pager.current = 1
      this.pager.size = size
      this.courseStudyData()
    },
    handleCurrentChange(current) {
      this.pager.current = current
      this.courseStudyData()
    },
    handleSelectionChange(val) {
      this.select = val
    },
  },
}
</script>

<style scoped lang="scss">
.Course {
  .header {
    ::v-deep .el-select .el-input {
      width: 235px;
    }
    ::v-deep .el-form-item {
      margin-right: 40px;
      margin-bottom: 0;
    }
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    .headerL {
      display: flex;
      align-items: center;
    }
  }
}
</style>
